export const sanitizeHtml = (html = "") => {
  if (!html) return "";

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${html}</div>`, "text/html");

    doc
      .querySelectorAll("script, iframe, object, embed, style")
      .forEach((node) => node.remove());

    doc.querySelectorAll("*").forEach((node) => {
      [...node.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();
        const value = attr.value.toLowerCase();

        if (name.startsWith("on")) {
          node.removeAttribute(attr.name);
        }

        if ((name === "href" || name === "src") && value.startsWith("javascript:")) {
          node.removeAttribute(attr.name);
        }
      });
    });

    return doc.body.innerHTML;
  } catch {
    return "";
  }
};

export const buildHeaderSlides = (settings = {}) => {
  const slides = [
    {
      src: settings.header_url1,
      text: settings.header_texte1,
      align: "left",
      alt: "Organisation de tournoi sportif",
    },
    {
      src: settings.header_url2,
      text: settings.header_texte2,
      align: "right",
      alt: "Tableau de score et compétition",
    },
  ].filter((slide) => Boolean(slide.src));

  if (slides.length) return slides;

  return [
    {
      src: "/img/header-tournoi.jpg",
      text: "Gérez vos compétitions, vos tableaux, vos scoreboards et vos résultats publics avec une seule application.",
      align: "left",
      alt: "Compétition sportive",
    },
  ];
};

export const getActiveSlide = (slides = [], currentIndex = 0) => {
  if (!slides.length) return null;

  return slides[currentIndex] || slides[0];
};